<div class="profile-shell" [class.faculty-shell]="isFacultyViewer()">
  @if (isFacultyViewer()) {
    <app-counselor-nav></app-counselor-nav>
  } @else {
    <app-student-nav></app-student-nav>
  }

  <main class="page" aria-live="polite">
    @if (loading()) {
      <div class="upv-state" data-testid="profile-loading">
        <mat-spinner diameter="32" aria-label="Loading profile"></mat-spinner>
      </div>
    } @else if (notFound()) {
      <div class="upv-state" data-testid="profile-not-found">
        <p>This profile isn't available.</p>
        <button mat-stroked-button class="btn-outline" (click)="goBack()">Go back</button>
      </div>
    } @else if (loadError()) {
      <div class="upv-state" data-testid="profile-error">
        <p>Something went wrong loading this profile.</p>
        <button mat-stroked-button class="btn-outline" (click)="goBack()">Go back</button>
      </div>
    } @else if (profile(); as p) {
      <div class="main-col">
        <!-- HERO -->
        <mat-card class="hero-card" data-testid="hero-card">
          <div class="hero-banner" aria-hidden="true"></div>
          <mat-card-content class="hero-body">
            <div class="hero-avatar upv-avatar">
              <app-user-avatar [imageUrl]="p.profilePicturePath" [name]="p.displayName" />
            </div>
            <div class="hero-info">
              <h1 class="hero-name" data-testid="hero-name">{{ p.displayName }}</h1>
              @if (careerLabel()) {
                <div class="hero-career" data-testid="hero-career">Future {{ careerLabel() }}</div>
              }
              @if (gradeLabel() || p.schoolName) {
                <div class="hero-meta">
                  <span class="hero-meta-item" data-testid="hero-meta-school">
                    <mat-icon class="meta-icon" aria-hidden="true">school</mat-icon>
                    {{ gradeLabel() }}{{ gradeLabel() && p.schoolName ? ' · ' : ''
                    }}{{ p.schoolName }}
                  </span>
                </div>
              }
              <div class="hero-actions">
                <button
                  mat-stroked-button
                  class="btn-outline"
                  data-testid="back-btn"
                  (click)="goBack()"
                >
                  <mat-icon aria-hidden="true">arrow_back</mat-icon> Back
                </button>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!-- ABOUT -->
        <mat-card class="section-card" data-testid="about-card">
          <mat-card-header class="section-header">
            <mat-card-title class="section-title">About</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="section-body">
            @if (p.bio) {
              <p class="about-text" data-testid="about-text">{{ p.bio }}</p>
            } @else {
              <p class="about-empty" data-testid="about-empty">No bio yet.</p>
            }
          </mat-card-content>
        </mat-card>

        <!-- DETAILS: only fields the server returned for this viewer -->
        @if (p.firstName || p.email || gradeLabel() || p.schoolName) {
          <mat-card class="section-card" data-testid="details-card">
            <mat-card-header class="section-header">
              <mat-card-title class="section-title">Profile details</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content class="section-body">
              <dl class="details-grid">
                @if (p.firstName) {
                  <div class="detail-item">
                    <dt class="detail-label">First name</dt>
                    <dd class="detail-value" data-testid="detail-first-name">{{ p.firstName }}</dd>
                  </div>
                }
                @if (gradeLabel()) {
                  <div class="detail-item">
                    <dt class="detail-label">Grade</dt>
                    <dd class="detail-value" data-testid="detail-grade">{{ gradeLabel() }}</dd>
                  </div>
                }
                @if (p.schoolName) {
                  <div class="detail-item">
                    <dt class="detail-label">School</dt>
                    <dd class="detail-value" data-testid="detail-school">{{ p.schoolName }}</dd>
                  </div>
                }
                @if (p.email) {
                  <div class="detail-item">
                    <dt class="detail-label">Email</dt>
                    <dd class="detail-value" data-testid="detail-email">{{ p.email }}</dd>
                  </div>
                }
              </dl>
            </mat-card-content>
          </mat-card>
        }

        <!-- INTERESTS -->
        <mat-card class="section-card" data-testid="interests-card">
          <mat-card-header class="section-header">
            <mat-card-title class="section-title">Hobbies & Interests</mat-card-title>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="section-body">
            @if (p.interests.length > 0) {
              <mat-chip-set class="interests-grid" aria-label="Interests">
                @for (interest of p.interests; track interest.id) {
                  <mat-chip class="interest-chip">{{ interest.name }}</mat-chip>
                }
              </mat-chip-set>
            } @else {
              <p class="about-empty" data-testid="interests-empty">No interests added yet.</p>
            }
          </mat-card-content>
        </mat-card>
      </div>
    }
  </main>
</div>
